<div class="main px-2">
  <div class="row g-3">
    <ng-container *ngIf="!somenteVisualizar">
      <div class="col-12">
        <app-documento-form [dataSet]="dataSet"></app-documento-form>
      </div>
    </ng-container>
    <nz-divider></nz-divider>
    <div class="col-12 d-flex flex-column page-content border border-radius w-100">
      <nz-table
        [nzData]="dataSet"
        [nzSize]="'small'"
        [nzFrontPagination]="false"
        [nzShowPagination]="false"
        (nzQueryParams)="sort($event)"
        [nzNoResult]="semDadosTemplate"
      >
        <thead>
          <tr>
            <th nzColumnKey="dataCadastro" nzWidth="150px" nzShowSort [nzSortFn]="true">Data do Cadastro</th>
            <th nzColumnKey="nomeDocumento" nzWidth="250px"  nzShowSort [nzSortFn]="true">Nome Documento</th>
            <th nzColumnKey="tipoDocumentoString" nzWidth="150px" nzShowSort [nzSortFn]="true">Tipo do Documento</th>
            <ng-container *ngIf="!somenteVisualizar">
              <th class="text-center" nzWidth="80px" [nzRight]="true">Ações</th>
            </ng-container>
          </tr>
        </thead>
        <tbody>
            <tr *ngFor="let item of dataSet">
              <td>{{ item?.dataCadastro | date: 'dd/MM/YYYY' }}</td>
              <td>
                <a nz-button nzType="link" class="link-azul" nz-popover nzPopoverContent="Download" nzPopoverPlacement="top" type="button" (click)="downloadDocumentos(item.arquivoId)">
                  {{ item?.nomeDocumento }}
                </a>
              </td>
              <td >{{ item?.tipoDocumentoString }}</td>
              <ng-container *ngIf="!somenteVisualizar">
                <td class="text-center" [nzRight]="true">
                  <button nz-button type="button" nz-dropdown [nzDropdownMenu]="menu">
                    <span nz-icon nzType="more" nzTheme="outline"></span>
                  </button>
                  <nz-dropdown-menu #menu="nzDropdownMenu">
                    <ul nz-menu>
                      <li nz-menu-item type="button" type="button" (click)="downloadDocumentos(item.arquivoId)">
                        <a>Download</a>
                      </li>
                      <li nz-menu-item type="button" type="button" (click)="deletarDocumentos(item)">
                        <a>Deletar</a>
                      </li>
                    </ul>
                  </nz-dropdown-menu>
                </td>
              </ng-container>
            </tr>
        </tbody>
      </nz-table>
      <ng-template #footerTemplate>
        <section class="d-flex justify-content-end w-100">
          <app-pagination [itemPorPagina]="10"></app-pagination>
        </section>
      </ng-template>
      <ng-template #semDadosTemplate>
        <div
          class="d-flex align-items-center justify-content-center"
          *ngIf="!dataSet?.length"
        >
          <nz-empty
            [nzNotFoundContent]="'Nenhum registro encontrado'"
          ></nz-empty>
        </div>
      </ng-template>
    </div>
  </div>
</div>
